import { KButton } from 'components/core/KButton'
import { styled } from '@mui/material/styles'

export const BottomBarActionButton = styled(KButton)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  minWidth: 280,
  height: 52,
  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
    minWidth: 200,
    height: 40,
  },
}))
